import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'
import {makeStyles} from '../theme/UNSTABLE_makeStyles'
import {Size} from '../types'

const baseClasses = {
  root: css`
    display: flex;
    justify-content: space-between;
    background-color: ${cssTheme.default.day.controlMinor};
  `,
  input: css`
    display: none;
  `,
  fullWidth: css`
    width: 100%;
  `,
  button: css``,
  error: css`
    // Cinnabar/Toxic
    outline: 2px solid ${cssTheme.colors.cinnabar.toxic};
  `,
}

const sizeClasses: Record<`size_${Size}`, string> = {
  size_xs: '',
  size_s: css`
    border-radius: ${spacing(1.625)};
  `,
  size_m: css`
    height: ${spacing(6)};
    border-radius: ${spacing(2)};
  `,
  size_l: '',
}

export const classes = {
  ...baseClasses,
  ...sizeClasses,
}
export type ClassKey = keyof typeof classes
export const useClasses = makeStyles(classes)
